export default __webpack_public_path__ + "static/media/nature.70ba96ad.jpg";